// Third Party Imports
import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import PropTypes from 'prop-types';
import {get} from 'lodash';

// Relative Imports
import appActions from '../../actions/actions';
import companyLocationActions from '../../actions/companyLocation';
import CompanyLocation from './CompanyLocation';
import helpActions from '../../actions/help';
import billingSetupActions from '../../actions/billingSetup';
import {excludeTaxIdentifier, isAddressFromQuebec, isEMEABrandSite, sanitizeAlphanumeric} from '../../utils/validate';
import {isVatEnabledCountry} from "../../utils/billingSetupSiteUtil";

function mapStateToProps(state) {
    return {
        publicUuid: get(state, 'app.publicUuid', '-1'),
        translations: state.app.translations,
        userType: get(state, 'app.userType', 'IPM'),
        pmscParams: state.app.pmscParams,
        enableContinueButton: get(state, 'companyLocation.enableContinueButton', false),
        firstName: get(state, 'basicInformation.firstName', ''),
        serviceError: get(state, 'companyLocation.serviceError', ''),

        companyName: get(state, 'companyLocation.companyName', ''),
        companyNameError: get(state, 'companyLocation.companyNameError', ''),

        countryList: get(state, 'companyLocation.countryList', []),
        companyCountryCode: get(state, 'companyLocation.companyCountryCode', ''),
        companyCountryCodeError: get(state, 'companyLocation.companyCountryCodeError', ''),

        businessType: get(state, 'companyLocation.businessType', ''),
        businessTypes: get(state, 'companyLocation.businessTypes', {}),
        businessTypeError: get(state, 'companyLocation.businessTypeError', ''),

        registrationNumberChoice: get(state, 'companyLocation.registrationNumberChoice', 'No'),
        showRegistrationNumberChoice: get(state, 'companyLocation.showRegistrationNumberChoice', false),
        registrationNumber: get(state, 'companyLocation.registrationNumber', ''),
        registrationNumberError: get(state, 'companyLocation.registrationNumberError', ''),

        vatChoice: get(state, 'companyLocation.vatChoice', 'Yes'),
        showVatChoice: get(state, 'companyLocation.showVatChoice', false),
        showBusinessType: get(state, 'companyLocation.showBusinessType', false),
        siteName: get(state, 'system.siteName', ''),
        basicInformation: get(state, 'basicInformation', {}),
        companyCountryInfo: get(state, 'companyLocation.companyCountryInfo', {}),
        redirectFlag: get(state, 'masterBrand.redirectFlag', true),
        isBillingSetupFlow: get(state, 'billingSetup.isBillingSetupFlow', false),
        vatCountryDetails: get(state, 'billingSetup.vatCountryDetails', []),
        billingSetupUserMeta: get(state, 'billingSetup.userMeta', {}),
        billingSetupFirstName: get(state, 'billingSetup.userMeta.firstName', ''),
        dyff: get(state,'app.dyff', {}),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        appActions: bindActionCreators(appActions, dispatch),
        companyLocationActions: bindActionCreators(companyLocationActions, dispatch),
        helpActions: bindActionCreators(helpActions, dispatch),
        billingSetupActions: bindActionCreators(billingSetupActions, dispatch),
        dispatch
    };
}

@connect(mapStateToProps, mapDispatchToProps)
class CompanyLocationContainer extends React.Component {
    constructor(props) {
        super(props);
        this.handleCompanyLocationChange = this.handleCompanyLocationChange.bind(this);
        this.handleCompanyNameChange = this.handleCompanyNameChange.bind(this);
        this.handleVatChoiceChange = this.handleVatChoiceChange.bind(this);
        this.handleRegistrationNumberChoiceChange = this.handleRegistrationNumberChoiceChange.bind(this);
        this.handleRegistrationNumberChange = this.handleRegistrationNumberChange.bind(this);
        this.handleFormSubmit = this.handleFormSubmit.bind(this);
        this.handleAlertDismiss = this.handleAlertDismiss.bind(this);
        this.handleBusinessTypeChange = this.handleBusinessTypeChange.bind(this);
        this.showOnFieldBlur = this.showOnFieldBlur.bind(this);
        this.triggerEdapPageViewAction = this.triggerEdapPageViewAction.bind(this);
        this.triggerEdapEventOnFocus = this.triggerEdapEventOnFocus.bind(this);
        this.handleBackButtonClick = this.handleBackButtonClick.bind(this);
    }

    componentWillMount() {
        this.props.appActions.enableLoadOverLay(true);
        this.props.companyLocationActions.verifySite(this.props.siteName, this.props.isBillingSetupFlow);
        this.props.companyLocationActions.getLocationMetadata();
    }

    setCompanyLocationByPmscParam() {
        const {companyCountry} = this.props.pmscParams;

        if (companyCountry) {
            this.props.companyLocationActions.handleFieldValueChange('companyLocation', companyCountry);
        }
    }

    triggerEdapPageViewAction() {
        this.props.appActions.triggerEdapPageView(this.props.publicUuid, 'Company Page');
    }

    triggerEdapEventOnFocus(e) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: e.target.name,
            eventaction: `on Focus:${e.target.name}`,
            highfrequency: 'true'
        });
    }

    handleAlertDismiss() {
        this.props.companyLocationActions.dismissAlertBox();
    }

    handleBillingSetupFlow() {
        const {companyCountryCode, vatCountryDetails, billingSetupUserMeta} = this.props;
        const billingAddress = billingSetupUserMeta.billingAddress;
        billingSetupUserMeta.companyCountryCode = companyCountryCode;

        this.props.billingSetupActions.updateBillingSetupMeta(billingSetupUserMeta, {});
        if (isVatEnabledCountry(vatCountryDetails, companyCountryCode) || isAddressFromQuebec(billingAddress)) {
            this.props.appActions.changeAppState('VAT_INFORMATION');
        } else {
            this.props.appActions.changeAppState('BILLING_INFORMATION');
        }
    }

    sendIneligibleEmail(ineligibilityType) {
        const {basicInformation, companyName, companyCountryInfo, vatChoice, businessType} = this.props;

        const helpFormData = {
            data: {
                firstName: basicInformation.firstName,
                lastName: basicInformation.lastName,
                emailAddress: basicInformation.email,
                companyLocation: companyCountryInfo.countryName || '',
                vatStatus: vatChoice,
                businessUnit: businessType,
                message: ineligibilityType,
                companyName
            },
            type: 'INELIGIBLE'
        };

        this.props.helpActions.submitHelpForm(helpFormData);
    }

    isInvalidVat = () => this.props.showVatChoice && this.props.vatChoice === 'No';
    isInvalidBusinessType = () => this.props.businessType === 'OTHER' && this.props.showBusinessType;
    isInvalidRegNo = () => this.props.registrationNumberChoice === 'No';
    isPrivateOwner = () => this.props.businessType === 'PO';
    isInvalidVatAndExcludeTaxIdentifier = () => this.isInvalidVat() && excludeTaxIdentifier(this.props.companyCountryCode);

    ineligibleIPM(ineligibilityType) {
        this.props.appActions.showIneligibleForm(ineligibilityType);
        if (!(ineligibilityType === 'INVALID_PRIVATE_OWNER' || ineligibilityType === 'INVALID_VAT_AND_EXCLUDE_TAX_IDENTIFIER')) {
            this.sendIneligibleEmail(ineligibilityType);
        }
    }

    handleFormSubmit(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Continue',
            eventaction: 'Company Page submit'
        }, {});
        let ineligibilityType;

        if (this.isPrivateOwner() && isEMEABrandSite(this.props.siteName)) {
            if (this.props.isBillingSetupFlow) {
                this.props.companyLocationActions.alertError("ipmob.company_location.error.unsupported_biz_type");
            } else {
                ineligibilityType = 'INVALID_PRIVATE_OWNER';
                this.ineligibleIPM(ineligibilityType);
            }
        } else if (this.isInvalidVatAndExcludeTaxIdentifier()) {
            // User indicated No VAT number and the country is ineligible for company registration number
            if (this.props.isBillingSetupFlow) {
                this.props.companyLocationActions.alertError("ipmob.company_location.error.vat_required");
            } else {
                ineligibilityType = 'INVALID_VAT_AND_EXCLUDE_TAX_IDENTIFIER';
                this.ineligibleIPM(ineligibilityType);
            }
        } else if (this.isInvalidVat()) {
            // User indicated No VAT number
            if (isEMEABrandSite(this.props.siteName)) {
                if (this.isInvalidRegNo()) {
                    // User indicated No Registration Number
                    if (this.props.isBillingSetupFlow) {
                        this.props.companyLocationActions.alertError("ipmob.company_location.error.tax_id_required");
                    } else {
                        ineligibilityType = 'INVALID_VAT_AND_INVALID_REG_NO';
                        this.ineligibleIPM(ineligibilityType);
                    }
                } else if (this.props.isBillingSetupFlow) {
                    // company registration is given by the user
                    const vatDetails = {
                        countryCode: this.props.companyCountryCode,
                        registrationNumber: this.props.registrationNumber
                    };
                    this.props.companyLocationActions.updateVatDetails(vatDetails, true);
                } else {
                    this.props.appActions.changeAppState('PROPERTY_COUNT');
                }
            } else {
                ineligibilityType = 'INVALID_VAT';
                this.ineligibleIPM(ineligibilityType);
            }
        } else if (this.isInvalidBusinessType() && !isEMEABrandSite(this.props.siteName)) {
            if (this.props.isBillingSetupFlow) {
                this.props.companyLocationActions.alertError("ipmob.company_location.error.unsupported_biz_type");
            } else {
                ineligibilityType = 'INVALID_BUSINESS_TYPE';
                this.ineligibleIPM(ineligibilityType);
            }
        } else if (this.props.isBillingSetupFlow) {
            // vat info is required from the user
            this.handleBillingSetupFlow()
        } else {
            this.props.appActions.changeAppState('PROPERTY_COUNT');
        }
    }

    handleCompanyNameChange(event) {
        event.preventDefault();
        this.setFieldsError(event.target.id);
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        if (!this.props.isBillingSetupFlow) {
            this.setCompanyLocationByPmscParam();
        }
        this.props.companyLocationActions.toggleContinueButton();
    }

    handleRegistrationNumberChange(event) {
        event.preventDefault();
        this.setFieldsError(event.target.id);
        const sanitizedValue = sanitizeAlphanumeric(event.target.value);
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, sanitizedValue);
        this.props.companyLocationActions.toggleContinueButton();
    }

    handleCompanyLocationChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: 'Company location selected',
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.companyLocationActions.setRegistrationNumberField(event.target.value, this.props.siteName);
        this.props.companyLocationActions.toggleContinueButton();
    }

    handleVatChoiceChange(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: (event.target.id === 'vatChoiceYes') ? 'VAT choice Yes selected' : 'VAT choice No selected',
            eventaction: 'VAT choice selected',
            highfrequency: 'true'
        });
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.companyLocationActions.toggleRegistrationNumberField(event.target.value, this.props.siteName);
        this.props.companyLocationActions.toggleContinueButton();
    }

    handleRegistrationNumberChoiceChange(event) {
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: (event.target.id === 'registrationNumberYes') ? 'Has Registration Number' : 'Has no Registration Number',
            eventaction: 'Registration Number choice selected',
            highfrequency: 'true'
        });
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.companyLocationActions.toggleContinueButton();
    }

    handleBusinessTypeChange(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.event', {
            eventcategory: event.target.name,
            eventaction: `Business type selected: ${event.target.value}`,
            highfrequency: 'true'
        }, {});
        this.setFieldsError(event.target.id);
        this.props.companyLocationActions.handleFieldValueChange(event.target.id, event.target.value);
        this.props.companyLocationActions.toggleContinueButton();
    }

    showOnFieldBlur(event) {
        event.preventDefault();
        if (!event.target.value.trim()) {
            this.setFieldsError(event.target.id);
            this.props.companyLocationActions.setFieldError(event.target.id, 'ipmob.input.field.required');
        }
    }

    setFieldsError(errorField) {
        const fields = [
            'companyName',
            'companyLocation',
            'vatChoice',
            'registrationNumberChoice',
            'registrationNumber',
            'businessType'
        ];

        for (const fieldVal of fields) {
            if (fieldVal === errorField) {
                this.props.companyLocationActions.setFieldError(fieldVal, '');
                break;
            }

            if ((fieldVal === 'companyName' && !this.props.companyName.trim())
                || (fieldVal === 'companyLocation' && !this.props.companyCountryCode)
                || (fieldVal === 'registrationNumber' && !this.props.registrationNumber)
                || (fieldVal === 'businessType' && !this.props.businessType)
            ) {
                this.props.companyLocationActions.setFieldError(fieldVal, 'ipmob.input.field.required');
            }
        }
    }

    handleBackButtonClick(event) {
        event.preventDefault();
        this.props.appActions.triggerEdapEvent('generic.click', {
            eventcategory: 'Back'
        });
        this.props.appActions.changeAppState('MASTER_BRAND');
    }

    render() {
        return (<div>
            <CompanyLocation
                translations={this.props.translations}
                countryList={this.props.countryList}
                userType={this.props.userType}

                companyCountryCode={this.props.companyCountryCode}
                handleCompanyLocationChange={this.handleCompanyLocationChange}
                companyCountryCodeError={this.props.companyCountryCodeError}
                handleCompanyLocationOnBlur={this.showOnFieldBlur}

                firstName={this.props.isBillingSetupFlow ? this.props.billingSetupFirstName : this.props.firstName}
                companyName={this.props.companyName}
                companyNameError={this.props.companyNameError}
                handleCompanyNameChange={this.handleCompanyNameChange}
                handleCompanyNameOnBlur={this.showOnFieldBlur}

                redirectFlag={this.props.redirectFlag}

                vatChoice={this.props.vatChoice}
                handleVatChoiceChange={this.handleVatChoiceChange}
                registrationNumberChoice={this.props.registrationNumberChoice}
                showRegistrationNumberChoice={this.props.showRegistrationNumberChoice}
                registrationNumber={this.props.registrationNumber}
                registrationNumberError={this.props.registrationNumberError}
                handleRegistrationNumberChoiceChange={this.handleRegistrationNumberChoiceChange}
                handleRegistrationNumberChange={this.handleRegistrationNumberChange}
                handleRegistrationNumberOnBlur={this.showOnFieldBlur}

                businessType={this.props.businessType}
                businessTypes={this.props.businessTypes}
                handleBusinessTypeChange={this.handleBusinessTypeChange}
                businessTypeError={this.props.businessTypeError}
                handleBusinessTypeOnBlur={this.showOnFieldBlur}

                serviceError={this.props.serviceError}
                handleAlertDismiss={this.handleAlertDismiss}
                enableContinueButton={this.props.enableContinueButton}
                handleFormSubmit={this.handleFormSubmit}
                showVatChoice={this.props.showVatChoice}
                showBusinessType={this.props.showBusinessType}
                triggerEdapPageViewAction={this.triggerEdapPageViewAction}
                triggerEdapEventOnFocus={this.triggerEdapEventOnFocus}
                handleBackButtonClick={this.handleBackButtonClick}
                siteName={this.props.siteName}
            />
        </div>);
    }
}

CompanyLocationContainer.propTypes = {
    translations: PropTypes.any, // eslint-disable-line react/forbid-prop-types
    publicUuid: PropTypes.string,
    companyCountryCode: PropTypes.string,
    countryList: PropTypes.array, // eslint-disable-line react/forbid-prop-types
    enableContinueButton: PropTypes.bool,
    serviceError: PropTypes.string,
    companyCountryCodeError: PropTypes.string,
    firstName: PropTypes.string,
    companyName: PropTypes.string,
    companyNameError: PropTypes.string,
    businessType: PropTypes.string,
    businessTypeError: PropTypes.string,
    vatChoice: PropTypes.string,
    showVatChoice: PropTypes.bool,
    showBusinessType: PropTypes.bool,
    siteName: PropTypes.string,
    userType: PropTypes.string,
    isBillingSetupFlow: PropTypes.bool,
};

CompanyLocationContainer.defaultProps = {
    publicUuid: '-1',
    companyCountryCode: '',
    countryList: [],
    enableContinueButton: false,
    serviceError: '',
    companyCountryCodeError: '',
    firstName: '',
    companyName: '',
    companyNameError: '',
    businessType: '',
    businessTypeError: '',
    vatChoice: '',
    showVatChoice: false,
    showBusinessType: false,
    siteName: '',
    userType: 'IPM'
};

export default CompanyLocationContainer;
